import { render } from "./DocumentFieldReferences.vue?vue&type=template&id=29c1453b"
import script from "./DocumentFieldReferences.vue?vue&type=script&lang=js"
export * from "./DocumentFieldReferences.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__